var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({on:{"click":function($event){return _vm.emitInput(!_vm.value)}}},'button',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.displayText)+" "),(_vm.tooltipClass)?_c('div',{class:_vm.tooltipClass},[_vm._v(" "+_vm._s(_vm.tooltipContent)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }